import React, { useState } from "react"
import styled from "styled-components"
import { Autoplay, Navigation, EffectFade } from "swiper"
import { Swiper, SwiperSlide } from "swiper/react"
import "swiper/swiper.css"
import "swiper/modules/navigation/navigation.min.css"
import "swiper/modules/effect-fade/effect-fade.min.css"
import FsLightbox from "fslightbox-react"

const EstateMainSlider = ({ slides = [] }) => {
  const [lightboxController, setLightboxController] = useState({
    toggler: false,
    slide: 1,
  })

  if (!slides || !slides.length) {
    return <></>
  }

  function openLightboxOnSlide(slide) {
    const index = slides.findIndex(url => url === slide)

    setLightboxController({
      slide: index + 1,
      toggler: !lightboxController.toggler,
    })
  }

  return (
    <>
      <Slider>
        <Swiper
          modules={[Autoplay, Navigation, EffectFade]}
          spaceBetween={50}
          slidesPerView={1}
          speed={1200}
          loop={true}
          effect={"fade"}
          autoplay={{ delay: 4000 }}
          navigation={{
            nextEl: ".slider-next",
            prevEl: ".slider-prev",
          }}
        >
          {slides.map(slide => (
            <SwiperSlide>
              <SliderItem>
                <div className="img">
                  <div>
                    <img
                      src={slide}
                      alt=" "
                      onClick={() => openLightboxOnSlide(slide)}
                    />
                  </div>
                </div>
              </SliderItem>
            </SwiperSlide>
          ))}
        </Swiper>
        { slides.length > 1 && (
          <>
          <div className="slider-next swiper-button-next" />
          <div className="slider-prev swiper-button-prev" />
          </>
        )}

      </Slider>
      <FsLightbox
        toggler={lightboxController.toggler}
        sources={slides}
        slide={lightboxController.slide}
      />
    </>
  )
}

export default EstateMainSlider

export const Slider = styled.div``

export const SliderItem = styled.div`
  overflow: hidden;

  .img {
    padding-top: ${Math.round((350 / 660) * 100)}%;
    position: relative;
    > div {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
    }
    img {
      //width: 100%;
      //height: 100%;
      //object-fit: cover;
      @media (min-width: 1024px) and (min-height: 768px) {
        max-height: 348px;
      }
      @media (min-width: 1200px) and (min-height: 768px) {
        max-height: 572px;
      }
      @media (min-width: 1400px) and (min-height: 768px) {
        max-height: 700px;
      }


    }
  }
  .body {
    padding: 15px;
  }
`
